import { forecastRoutes } from '../../../common/translation/translate';

export function getLocationUrl(routePath, locationRouteString) {
    return routePath.includes(':location')
        ? routePath.replace(':location', locationRouteString)
        : routePath + locationRouteString;
}

export function getRoutePath(routePath) {
    return !routePath || routePath === '/' ? forecastRoutes.now : routePath;
}
